import React from 'react'
import { Outlet, useNavigate } from 'react-router-dom'
import './Authentication.scss'

export default function AuthWrapper() {
    const navigate = useNavigate();
    return (
        <div className='auth_wrapper'>
            <div className="left">
                <div className="logo">
                    <img src={`${process.env.PUBLIC_URL}/images/logo-footer.png`} alt="" />
                </div>
            </div>
            <div className="right">
                <div className="logo" onClick={() => navigate("/")} style={{ cursor: 'pointer' }}>
                    <img src={`${process.env.PUBLIC_URL}/images/blue-logo.png`} alt="" />
                </div>
                <div className="content_wrapper">
                    <Outlet />
                </div>
            </div>
        </div>
    )
}
